import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import "./style.css";

const VaporContentSwitcherTab = props => {
  const { className = "", items, itemsWidth, selected, onChange} = props;

  let itemStyle = {};
  if (itemsWidth) {
    itemStyle.width = itemsWidth;
    
  }

  const renderItems = () => {
    let itRet = [];
    if (items && typeof items === "object" && items.length > 1) {
      let cn = 0;
      items.map(it => {
        cn++;
        if ((it?.icon || it?.label) && it?.value) {
          itRet.push(<div
            key={"dbx-vapor-content-switcher-tab_" + it.value}
            className={ className + 
                            " dbx-vapor-content-tab" + 
                            (cn === 1 ? " left" : cn === items.length ? " right" : "") + 
                            (selected === it.value ? " active" : "")
            }
            style={itemStyle}
            onClick={() => {
              if (onChange) {
                onChange(it.value);
              }
            }}
          >
            {it.icon && (
              <FontAwesomeIcon
                icon={["far", it.icon]}
                style={{
                  fontSize: 16,
                  marginRight: "8px"
                }}
              />
            )}
            {it.label || null}
          </div>);
        }
        return null;
      });
    }
    return itRet;
    
  };

  return <div className="dbx-vapor-content-tab-root">{renderItems()}</div>;
};

VaporContentSwitcherTab.propTypes = {
  items: PropTypes.array,
  itemsWidth: PropTypes.number,
  onChange: PropTypes.func,
  selected: PropTypes.string
};

export default VaporContentSwitcherTab;
